module.exports = "<div ng-switch=$ctrl.helpMenuType> <dt-application-help ng-switch-when=APPLICATION_HELP on-show-feedback-form=$ctrl.showFeedbackForm()> </dt-application-help> <dt-feedback-form ng-switch-when=FEEDBACK_FORM on-cancel=$ctrl.cancel()> </dt-feedback-form> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/help-menu/help-menu.html
// module id = Acgv
// module chunks = 1